import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { PermissionService } from '../../services/permission.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {

  isDownloaderPro: boolean = false;
  isAnalyzerPro: boolean = false;
  canSeeRtkExpert: boolean = false;
  canSeeExternalConnections: boolean = false;
  isDemo = false;

  constructor(public auth: AuthService, private router: Router, private perms: PermissionService) {
    // 在路由切换后刷新权限，确保不同页面都能正确显示管理员菜单
    this.router.events.subscribe(ev => {
      if (ev instanceof NavigationEnd) {
        this.loadPermissions(false);
      }
    });
  } 


  ngOnInit(): void {
    this.loadPermissions(true);
    // 订阅权限变化，实时更新菜单显隐
    this.perms.permissionsChanged$.subscribe(_ => this.applyPermissions());
  }  

  logOut(): void {
    this.auth.logOut();
    // 如果需要，这里还可以添加一些逻辑来处理登出后的用户界面变化，如重定向等
  }

  retrieveUserPermissions(): void {
    this.loadPermissions(false);
  }

  private loadPermissions(firstTry: boolean): void {
    // 改为本地解析 JWT
    this.perms.ensureFresh();
    this.applyPermissions();
  }

  private applyPermissions(): void {
    this.isDownloaderPro = this.perms.hasAny(['downloader-pro']);
    this.isAnalyzerPro = this.perms.hasAny(['analyzer-pro']);
    this.isDemo = this.perms.has('demo');
    // "RTK Expert Tool Suite" menu should be visible for ALL authenticated users.
    // Pro-only submenus remain permission-gated in the template.
    this.canSeeRtkExpert = this.auth.isLoggedIn();
    // Keep this flag in case other templates still reference it.
    this.canSeeExternalConnections = this.auth.isLoggedIn();
  }

}
